import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "intro-section" }
const _hoisted_2 = {
  class: "brand-name",
  style: {"font-size":"1.5rem","color":"var(--text-heading)"}
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "highlight" }

import { content } from "@/content/data";
import { ExternalLink } from "lucide-vue-next";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutMe',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "section-title" }, "About Me", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" Hi! I'm ", -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(content).name), 1),
        _createTextVNode(". " + _toDisplayString(_unref(content).about.intro) + " Currently Working in ", 1),
        _createElementVNode("a", {
          href: _unref(content).about.currentWork.url,
          target: "_blank",
          class: "inline-link"
        }, [
          _createTextVNode(_toDisplayString(_unref(content).about.currentWork.text) + " ", 1),
          _createVNode(_unref(ExternalLink), {
            size: 15,
            "stroke-width": "1.8"
          })
        ], 8, _hoisted_3),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(content).about.bio) + " If you want to trade ", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content).about.interests, (interest, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(interest), 1),
            (i < _unref(content).about.interests.length - 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(", ")
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _cache[2] || (_cache[2] = _createTextVNode(" (or just say hi), you can find my ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Instagram", -1)),
        _cache[4] || (_cache[4] = _createTextVNode(", ", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Email", -1)),
        _cache[6] || (_cache[6] = _createTextVNode(" and ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("strong", null, "LinkedIn", -1)),
        _cache[8] || (_cache[8] = _createTextVNode(" links in the top right corner. ", -1))
      ])
    ])
  ]))
}
}

})